import React, { useCallback } from 'react';
import type { UseFormRegister, UseFormWatch, UseFormSetValue } from 'react-hook-form';
import type { LessonFormValues } from '../schemas/lessonSchema';

interface IltsFieldsProps {
  register: UseFormRegister<LessonFormValues>;
  watch: UseFormWatch<LessonFormValues>;
  setValue: UseFormSetValue<LessonFormValues>;
}

const IltsFields: React.FC<IltsFieldsProps> = ({ register, watch, setValue }) => {
  const iltsType = watch('iltsType');

  const handleIltsTypeChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
    const newType = e.target.value as 'Online' | 'Offline';
    setValue('iltsType', newType);
    if (newType === 'Online') {
      setValue('eventVenue', '');
    } else {
      setValue('meetUrl', '');
    }
  }, [setValue]);

  const selectStyle = {
    padding: '10px',
    fontSize: '14px',
    fontWeight: '500' as const,
    cursor: 'pointer',
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '6px',
  };

  return (
    <>
      {/* Session Type */}
      <div className="form-row">
        <div className="form-group">
          <label>Session Type *</label>
          <select value={iltsType} onChange={handleIltsTypeChange} className="form-select" style={selectStyle}>
            <option value="Online">Online</option>
            <option value="Offline">Offline</option>
          </select>
        </div>
      </div>

      {/* Start & End Date/Time */}
      <div className="form-row">
        <div className="form-group">
          <label>Start Date & Time</label>
          <div style={{ display: 'flex', gap: '10px' }}>
            <input type="date" {...register('startDate')} className="form-input" style={{ flex: 1 }} />
            <input type="time" {...register('startTime')} className="form-input" style={{ flex: 1 }} />
          </div>
        </div>
        <div className="form-group">
          <label>End Date & Time</label>
          <div style={{ display: 'flex', gap: '10px' }}>
            <input type="date" {...register('endDate')} className="form-input" style={{ flex: 1 }} />
            <input type="time" {...register('endTime')} className="form-input" style={{ flex: 1 }} />
          </div>
        </div>
      </div>

      {/* Online: Meeting URL */}
      {iltsType === 'Online' && (
        <div className="form-row">
          <div className="form-group">
            <label>Meeting URL</label>
            <input
              type="url"
              {...register('meetUrl')}
              placeholder="https://zoom.us/j/123456789"
              className="form-input"
            />
          </div>
        </div>
      )}

      {/* Offline: Venue */}
      {iltsType === 'Offline' && (
        <div className="form-row">
          <div className="form-group">
            <label>Venue</label>
            <input
              type="text"
              {...register('eventVenue')}
              placeholder="Enter venue address"
              className="form-input"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default IltsFields;
